<template>
  <div class="my-warning">
    <span class="title">环保手册</span>
    <div class="my-warning-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <el-input
                size="small"
                placeholder="请输入文件名称关键字"
                prefix-icon="el-icon-search"
                v-model="searchParams.name"
              >
              </el-input>
            </div>
          </div>
          <div class="search-action">
            <el-button
              size="small"
              icon="el-icon-search"
              type="primary"
              @click="getList()"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh"
              plain
              @click="onReset()"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div style="padding-bottom: 5px">
        <el-button
          v-auth="'Government'"
          size="small"
          icon="el-icon-upload"
          @click="openUpload()"
          >上传</el-button
        >
        <el-button
          v-auth="'Government'"
          type="danger"
          size="small"
          icon="el-icon-delete"
          @click="batchDelete()"
          >删除</el-button
        >
      </div>

      <el-table
        size="small"
        ref="envTable"
        height="calc(100% - 180px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column v-if="isGovernment()" type="selection" width="55">
        </el-table-column>
        <el-table-column align="center" label="序号" width="100">
          <template scope="scope">
            <span>{{
              (pagination.current - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="isGovernment()"
          width="100"
          align="center"
          prop="number"
          label="排序"
        >
          <template scope="{ row  }">
            <span>{{ row.number == 0 ? "置顶" : row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="文件名称">
        </el-table-column>

        <el-table-column
          align="center"
          prop="clicks"
          width="120"
          label="点击量"
        >
        </el-table-column>

        <el-table-column align="center" label="操作" fixed="right" width="220">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              v-auth="'Government'"
              size="mini"
              @click="editRow(row)"
              >编辑</el-button
            >

            <el-button
              type="text"
              v-auth="'Government'"
              style="color: #f56c6c"
              size="mini"
              @click="deleteRow(row.id)"
              >删除</el-button
            >

            <el-button size="mini" type="text" @click="previewFile(row)"
              >预览</el-button
            >

            <el-button size="mini" type="text" @click="downloadFile(row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <uploadFile
      ref="uploadFile"
      @getData="getList()"
      :accept="accept"
      :url="$api.envManualFiles.upload"
    ></uploadFile>
    <previewFile
      ref="previewFile"
      :fileUrl="fileUrl"
      :fileName="fileName"
      :tabView="tabView"
    ></previewFile>
    <el-dialog :title="fileName" :visible.sync="imgVisible">
      <img width="100%" height="100%" :src="fileUrl" v-if="imgVisible" />
    </el-dialog>

    <el-dialog title="修改" :visible.sync="editVisible">
      <el-form ref="form" :model="form" size="small" label-width="150px">
        <el-form-item label="文件名称：" prop="name">
          <el-input style="width: 80%" type="text" v-model="form.name" />
        </el-form-item>
        <el-form-item label="是否置顶" prop="name">
          <el-switch
            v-model="isPinTop"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="序号" prop="name" v-if="!isPinTop">
          <el-input
            min="1"
            style="width: 80%"
            type="text"
            v-model="form.number"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="GLOBAL.token" @click="editVisible = false"
          >取 消</el-button
        >
        <el-button
          :size="GLOBAL.token"
          type="primary"
          @click="editSubmit('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";
import { DownloadBlob } from "@/http/downloadService";

import uploadFile from "./components/upload.vue";
import previewFile from "./components/previewFile";
export default {
  components: { uploadFile, previewFile },
  data() {
    return {
      dataSource: [],
      searchParams: {
        name: "",
      },
      accept: ".xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png",
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      editVisible: false,
      isPinTop: true,
      form: {
        id: 0,
        name: "",
        number: 0,
      },
      fileUrl: "",
      fileName: "",
      tabView: "",
      imgVisible: false,
    };
  },
  //监控data中的数据变化
  watch: {
    isPinTop: function (val) {
      this.form.number = val ? 0 : 1;
    },
  },
  computed: {},
  methods: {
    isGovernment() {
      // 获取权限数组
      let permissionData = sessionStorage.getItem("permission") || "";

      // permissionData = permissionData.split(",");

      // 检查每个权限是否都在权限数组中
      return permissionData.includes("Government");
    },

    editRow(row) {
      const { id, name, number } = row;
      this.isPinTop = number == 0;
      this.form.id = id;
      this.form.name = name;
      this.form.number = number;
      this.editVisible = true;
    },
    editSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let datas = this.form;
          let url = `${this.$api.envManualFiles.modify}`;
          let formData = new FormData(); //  用FormData存放上传文件
          for (let p in datas) {
            if (datas.hasOwnProperty(p)) {
              let data = datas[p];
              formData.append(p, data);
            }
          }
          this.$axios.post(url, formData, false).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.editVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        }
      });
    },
    previewFile(row) {
      let baseUrl = process.env.VUE_APP_BASEURL;
      let url = this.$api.envManualFiles.download + "/" + row.guid;
      let hz = row.name.substring(row.name.lastIndexOf(".") + 1);

      let isOffice = false;
      let isPrevire = true;
      switch (hz) {
        // case "doc":
        case "docx":
        case "doc":
        case "xlsx":
        case "xls":
        case "pptx":
        case "ppt":
          isOffice = true;
          break;
        case "pdf":
          this.tabView = "VueOfficePdf";
          break;
        case "jpg":
        case "png":
          this.imgVisible = true;
          break;
        default:
          isPrevire = false;
          break;
      }
      if (!isPrevire) {
        this.$message("当前文件格式暂不支持预览。");
        return;
      }
      if (isOffice) {
        window.open(
          `http://view.officeapps.live.com/op/view.aspx?src=${baseUrl + url}`
        );
      } else {
        this.fileName = row.name;
        this.fileUrl = baseUrl + url;
        if (!this.imgVisible) this.$refs.previewFile.visible = true;
      }
    },
    deleteRow(id) {
      this.$confirm("此操作将永久删除此项, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let url = this.$api.envManualFiles.delete + "/" + id;
        this.$axios.del(url, false).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      });
    },
    batchDelete() {
      let checkRows = this.$refs.envTable.selection;

      console.log(checkRows);
      if (checkRows.length <= 0) {
        this.$message({
          message: "请先选中需要删除的文件",
          type: "warning",
        });
        return;
      }

      this.$confirm("此操作将永久删除此项, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const ids = checkRows.map((r) => r.id).join(",");

        let url = this.$api.envManualFiles.batchDelete + "?ids=" + ids;
        this.$axios.del(url, false).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      });
    },
    downloadFile(row) {
      let url = this.$api.envManualFiles.download + "/" + row.guid;
      DownloadBlob({
        url: url,
        method: "get",
      });
    },
    openUpload() {
      this.$refs.uploadFile.visible = true;
    },
    getList() {
      const parames = {
        ...this.searchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.envManualFiles.getList;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.searchParams = {
        name: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }

  .select-searchmain1 {
    width: 100%;
    // height: 70px;
    display: flex;
    padding: 5px 0px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      // padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style> 